import React from "react";
import type { BusinuessCusotmerAdvantagesSlice } from "~/lib/prismic";
import type { SliceComponentProps } from "@commercekit/prismic";
import { asText } from "@prismicio/helpers";

const BusinuessCusotmerAdvantages = ({
  slice,
}: SliceComponentProps<BusinuessCusotmerAdvantagesSlice>) => (
  <div className="text-center my-3 mt-lg-0">
    <h2 className="heading strong lg sans-serif underlined mb-3 pb-3">
      {asText(slice.primary.title)}
    </h2>

    <div className="customer__usps px-3 py-4">
      {slice.items &&
        slice.items.map((item) => (
          <div
            key={asText(item.advantage)}
            className="customer__usp heading mdl mb-3"
            data-icon-before=""
          >
            {asText(item.advantage)}
          </div>
        ))}
    </div>
  </div>
);

export default BusinuessCusotmerAdvantages;
